import { addDays, format, isSameDay, subDays } from "date-fns";

export const AttendanceModule = {
  namespaced: true,

  state: {
    attendance_date_truth: new Date(),
    phase_id: null,
    stage_id: null,
    home_class_id: null,
    class_group_id: null,
    class_groups: [],
  },
  getters: {
    attendance_date_filter: state => {
      return format(state.attendance_date_truth, localStorage.getItem("dateFormat") ?? "yyyy-MM-dd");
    },
    is_today: state => {
      return isSameDay(new Date(), state.attendance_date_truth);
    },
    home_class_attendances: state => state.home_class_attendances,
  },
  actions: {
    back_days({ commit, state }, num = 1) {
      commit("SET_DATE", subDays(state.attendance_date_truth, num));
    },
    forward_days({ commit, state }, num = 1) {
      commit("SET_DATE", addDays(state.attendance_date_truth, num));
    },
    set_attendance_date({ commit }, date) {
      commit("SET_DATE", date);
    },
  },

  mutations: {
    SET_DATE(state, date) {
      state.attendance_date_truth = date;
    },
    SET_PHASE_ID(state, id) {
      state.phase_id = id;
    },
    SET_STAGE_ID(state, id) {
      state.stage_id = id;
    },
    SET_HOME_CLASS_ID(state, id) {
      state.home_class_id = id;
    },
    SET_CLASS_GROUP_ID(state, id) {
      state.class_group_id = id;
    },
    SET_CLASS_GROUPS(state, groups) {
      state.class_groups = groups;
    },
  },
};
